import React, { useContext, useEffect, useState } from 'react';
import { ProductHelper, productHelper as commonProductHelper } from 'helpers';
import { DiscoveryService } from '@teko/discovery';

export interface HelperState {
  productHelper?: ProductHelper;
  setProductHelper?: React.Dispatch<React.SetStateAction<ProductHelper>>;
}

export interface HelperProviderProps {
  children: React.ReactNode;
  discoveryPos365Service: DiscoveryService;
  freeShippingThreshold?: number;
}

const HelperStateContext = React.createContext<HelperState>({});

export const HelperProvider: React.FunctionComponent<HelperProviderProps> = ({
  children,
  freeShippingThreshold,
}: HelperProviderProps) => {
  const [productHelper, setProductHelper] = useState(commonProductHelper);

  useEffect(() => {
    if (typeof freeShippingThreshold !== 'number') {
      return;
    }

    if (freeShippingThreshold >= 0) {
      setProductHelper(new ProductHelper(freeShippingThreshold));
    } else {
      setProductHelper(new ProductHelper(null));
    }
  }, [freeShippingThreshold]);

  return (
    <HelperStateContext.Provider value={{ productHelper, setProductHelper }}>
      {children}
    </HelperStateContext.Provider>
  );
};

export function useHelper(): HelperState {
  const context = useContext(HelperStateContext);
  if (!context) {
    throw new Error(
      'useHelper must be inside a HelperStateContext with a state value',
    );
  }
  return context;
}
